export default __webpack_public_path__ + "1ac86623910eed10e94468d7eab8d90a.png";